export default "__VITE_ASSET__iR5_Cc5T__"